import CurrentUser from 'auth/CurrentUser';
import cx from 'classnames';
import Link from 'components/Link';
import LoadingIndicator from 'components/LoadingIndicator';
import PropTypes from 'prop-types';
import * as React from 'react';

class TranslationCTA extends React.Component<
  {
    onLanguageChange: Function;
    originLanguage: string;
    className?: string;
  },
  any
> {
  static contextTypes = {
    eventContextName: PropTypes.string,
  };

  state = {
    currentLocal: this.props.originLanguage,
  };

  showOriginal = () => {
    const originLocal = this.props.originLanguage;
    this.props.onLanguageChange(originLocal);
    this.setState({ translating: false, currentLocal: originLocal });
  };

  toggle = () => {
    return CurrentUser.getUser().getISO639Locale() === this.state.currentLocal
      ? this.showOriginal()
      : this.translate();
  };

  translate = () => {
    const userLocale = CurrentUser.getUser().getISO639Locale();
    this.props.onLanguageChange(userLocale);
    this.setState({ translating: true, currentLocal: userLocale });
  };

  translated = () => {
    this.setState({ translating: false });
  };

  render() {
    if (!CurrentUser.isSignedIn()) {
      return null;
    }

    const userLocale = CurrentUser.getUser().getISO639Locale();
    const originLocal = this.props.originLanguage;

    if (!userLocale || !originLocal || userLocale === originLocal) {
      return null;
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'translating' does not exist on type '{ c... Remove this comment to see the full error message
    if (userLocale === this.state.currentLocal && !this.state.translating) {
      return (
        <span className={this.props.className}>
          <Link
            eventElementName="translation_show_orignal"
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; eventElementName: string... Remove this comment to see the full error message
            eventContextName={this.context.eventContextName}
            onClick={this.showOriginal}
          >
            Show original
          </Link>
        </span>
      );
    }

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'translating' does not exist on type '{ c... Remove this comment to see the full error message
    const color = this.state.translating ? 'graphite' : 'mascot';

    return (
      <span className={cx('GroupMessageHeader-Translate', this.props.className)}>
        <Link
          onClick={this.translate}
          eventElementName="translation_show_translation"
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ children: string; onClick: () => void; eve... Remove this comment to see the full error message
          eventContextName={this.context.eventContextName}
          color={color}
          className="GroupMessageHeader-TranslateLink"
        >
          Show translation
        </Link>

        {/* @ts-expect-error ts-migrate(2339) FIXME: Property 'translating' does not exist on type '{ c... Remove this comment to see the full error message */}
        {this.state.translating ? <LoadingIndicator size="xsmall" /> : null}
      </span>
    );
  }
}

export default TranslationCTA;
